import { Component, inject } from '@angular/core';
import { NzLayoutComponent } from 'ng-zorro-antd/layout';
import { RouterOutlet } from '@angular/router';
import { SurveyInfoComponent } from '@app/layouts/survey/survey-info/survey-info.component';
import { NzButtonComponent } from 'ng-zorro-antd/button';
import { NzIconDirective } from 'ng-zorro-antd/icon';
import { SurveyLayoutService } from '@app/layouts/survey/layout/survey-layout.service';

@Component({
  selector: 'math-survey-layout',
  imports: [
    NzLayoutComponent,
    RouterOutlet,
    SurveyInfoComponent,
    NzButtonComponent,
    NzIconDirective,
  ],
  templateUrl: './survey-layout.component.html',
  styleUrl: './survey-layout.component.scss',
})
export class SurveyLayoutComponent {
  protected surveyLayoutService = inject(SurveyLayoutService);
}
